import icon from '@material-ui/icons/Person'

const markets = { icon, options: { label: 'Markets' } }

export default markets
